
export const PathStrings = {
  AssemblyInstructions: "assemble",
  LoadDiceKey: "load",
  SeedFidoKey: "seed"
} as const;